module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1VIkT"))).then(() => parcelRequire('d0iPb'));